import ButtonT from '@components/tailwind-components/Button/ButtonT';
import { toastWarningTranslated } from '@helpers/toast';
import { useBlocks } from '@hooks/flow/block/useBlocks';
import { useBlocksActions } from '@hooks/flow/block/useBlocksActions';
import { useModal } from '@hooks/modal/useModal';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface ModalRevisionSetContentBodyProps {
  onSubmit: () => void;
}

// ? Do we need a more generic modal for this type of confirm/discard/abort operation
export const SwitchRevisionModal: React.FC<ModalRevisionSetContentBodyProps> = (
  props,
) => {
  const { onSubmit } = props;
  const { hideModal } = useModal();
  const { t } = useTranslation();
  const { saveFlow } = useBlocksActions();

  const { hasButtonBlocksWithoutDestination } = useBlocks();

  const handleSaveClick = useCallback(async () => {
    // The warning should be given when saving the flow if there are button blocks without a destination
    if (hasButtonBlocksWithoutDestination) {
      toastWarningTranslated(
        'flow.blocks.save.button.no-destination.toast.warning',
      );
    }

    await saveFlow();
    return onSubmit();
  }, [hasButtonBlocksWithoutDestination, saveFlow, onSubmit]);

  return (
    <div className='tailwind-modal-form'>
      <div className='tailwind-modal-body'>
        <p className='text-sm'>{t('modals.flow.blocks.changes.description')}</p>
        <br />
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='submit'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={() => hideModal()}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT
          type='submit'
          styling='primary'
          size='xs'
          rounding='md'
          onClick={() => onSubmit()}>
          {t('modals.flow.confirm.discard')}
        </ButtonT>
        <ButtonT
          type='submit'
          styling='primary'
          size='xs'
          rounding='md'
          onClick={() => {
            handleSaveClick();
          }}>
          {t('modals.flow.confirm.save')}
        </ButtonT>
      </div>
    </div>
  );
};
